import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useMainStore = defineStore('main', () => {
	const isFastOrderPopup = ref(false);
	const completeOrder    = ref(false);
	const isClosePopup     = ref(false);
	const sesson_id        = ref(null);
	const newsletterLink   = ref('');

	const formData = ref([
		{
			name   : null,
			drafts : [],
			photos : [],
		},
	]);

	const setNewsletterLink = (link: string) => newsletterLink.value = link;

	return {
		isFastOrderPopup,
		newsletterLink,
		completeOrder,
		isClosePopup,
		sesson_id,
		formData,

		setNewsletterLink
	};
})